class SearchController {
  constructor() {
    let ajaxType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7383;
    let onResultsUpdated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.ajaxType = ajaxType;
    this.onResultsUpdated = onResultsUpdated;
    this.scrollToTopOfElement = ($element, deltaTop) => {
      window.scrollTo({
        top: $element.offsetTop - deltaTop,
        behavior: 'smooth'
      });
    };
  }
  init() {
    document.querySelectorAll('.solr-ajaxified').forEach($link => {
      const href = $link.getAttribute('href');
      if (window.location.href.indexOf(href) >= 0) {
        $link.classList.add('active');
      }
    });
    const $allLink = document.querySelector('.solr-ajaxified[href*="all"]');
    if (!document.querySelectorAll('.solr-ajaxified.active').length && $allLink) {
      $allLink.classList.add('active');
    }
    document.addEventListener('click', e => {
      const $target = e.target;
      const $solrAjaxified = $target.classList.contains('js-solr-ajaxified') ? $target : $target.closest('.solr-ajaxified');
      if ($solrAjaxified) {
        e.preventDefault();
        this.handleClickOnAjaxifiedUri($solrAjaxified);
      }
    });
  }
  handleClickOnAjaxifiedUri($link) {
    const $solrContainer = $link.closest('.tx_solr');
    if ($link.classList.contains('search-list-group-link')) {
      $solrContainer.querySelectorAll('.solr-ajaxified.active').forEach($active => $active.classList.remove('active'));
    }
    $link.classList.add('active');
    const href = $link.getAttribute('href');
    const $mainSearchTabs = document.querySelector('.main-search-tabs');
    const $mainSearchResult = document.querySelector('.search-result-list');
    if ($mainSearchResult && $mainSearchTabs) {
      $mainSearchTabs.classList.add('loading');
      $mainSearchResult.classList.add('loading');
    }
    fetch(`${href}&type=${this.ajaxType}`).then(res => res.text()).then(data => {
      const $template = document.createElement('template');
      $template.insertAdjacentHTML('afterbegin', data);
      const $tempSearchResult = $template.querySelector('.search-result-list');
      const $tempSearchPagination = $template.querySelector('.solr-pagination');
      if ($tempSearchResult) {
        const $resultList = $solrContainer.querySelector('.search-result-list');
        $resultList.innerHTML = $tempSearchResult.innerHTML;
        if (this.onResultsUpdated) {
          this.onResultsUpdated($resultList);
        }
      }
      if ($tempSearchPagination) {
        $solrContainer.querySelector('.solr-pagination').innerHTML = $tempSearchPagination.innerHTML;
      }
      this.scrollToTopOfElement($solrContainer, 50);
      window.history.replaceState({}, null, href);
      if ($mainSearchResult && $mainSearchTabs) {
        $mainSearchTabs.classList.remove('loading');
        $mainSearchResult.classList.remove('loading');
      }
    });
  }
  setAjaxType(ajaxType) {
    this.ajaxType = ajaxType;
  }
}
export default SearchController;